import { isValidElement } from 'react';
import IconHighlight from '../IconHighlight.jsx';
import { resolveHighlightCardIconHighlight } from './highlightCardClasses.js';

export function handleHighlightCardKeyDown(event, onActivate) {
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    onActivate?.();
  }
}

/** Figma formats value as `00,000`; use locale grouping. Disabled → `-`. */
export function formatHighlightCardValue(value, state) {
  if (state === 'disabled') return '-';

  if (value == null || value === '') return '-';

  if (typeof value === 'number' && Number.isFinite(value)) {
    return value.toLocaleString();
  }

  return String(value);
}

export function renderHighlightCardIcon(icon, variant, iconHighlight, state, showIcon = true) {
  if (!showIcon || icon == null || icon === false) return null;
  if (isValidElement(icon)) return icon;

  const isDisabled = state === 'disabled';

  if (typeof icon === 'function' || (typeof icon === 'object' && icon !== null)) {
    const {
      bgColor,
      iconColor,
      size,
      className,
      ...rest
    } = resolveHighlightCardIconHighlight(variant, iconHighlight);

    return (
      <IconHighlight
        icon={icon}
        bgColor={isDisabled ? 'Neutral' : bgColor}
        iconColor={isDisabled ? 'Primary' : iconColor}
        size={size}
        className={[
          isDisabled ? 'opacity-70 saturate-0' : '',
          className,
        ]
          .filter(Boolean)
          .join(' ')}
        {...rest}
      />
    );
  }

  return null;
}
